import React, { FC, ReactElement } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";

interface Props {
    onNewProduct: () => void;
    onCreateDeveloperProject: () => void;
    newProjectLabel?: string;
}

export const CreateNewDropdown: FC<Props> = ({
    onNewProduct,
    onCreateDeveloperProject,
    newProjectLabel = "New Project"
}) => {
    const handleSelect = (eventKey: string | null) => {
        if (eventKey === "create-new-product") {
            onNewProduct();
        } else if (eventKey === "create-new-project-dev") {
            onCreateDeveloperProject();
        }
    };

    const alternatives: ReactElement[] = [];
    alternatives.push(
        <Dropdown.Item key="create-new-product" eventKey="create-new-product">
            New Product
        </Dropdown.Item>
    );

    alternatives.push(
        <Dropdown.Item
            key="create-new-project-dev"
            eventKey="create-new-project-dev"
        >
            {newProjectLabel}
        </Dropdown.Item>
    );

    return (
        <DropdownButton
            id="create-new-dropdown"
            title="Create New"
            variant="primary"
            onSelect={handleSelect}
            className="pb-1"
            size="sm"
        >
            {alternatives}
        </DropdownButton>
    );
};
